import { useEffect, useState } from 'react';
import { Box, Grid, ToggleButtonGroup } from '@mui/material';
import { StyledToggleButton } from '../../Inventory/Inventory';
import BenefitCard from './Components/BenefitCard';
import { getAllInsurances } from './APIs/action';
import { toast } from 'react-toastify';
import { trackAnalyticsEvent } from '../../../utils/clevertap';
import { useSelector } from 'react-redux';
import Entity from '../../../v3/Common/Entity';

const Benefits = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [insuranceData, setInsuranceData] = useState([]);
  const userData = useSelector(state => state.user?.userData);

  const { selectedSupplier: selectedManufacturer, selectedEntity: selectedCompanyEntity } = useSelector(
    (state) => state.entityReducer
  );

  const handleTabChange = (_, newValue) => {
    if (newValue !== null) {
      // Track tab change event
      trackAnalyticsEvent('BENEFICIARY_TAB_CHANGE', {
        manufacturer_id: userData?.manufacturer_id || '',
        tab_name: insuranceData[newValue]?.display_name || '',
        tab_index: newValue
      });
      
      setSelectedTab(newValue);
    }
  };

  const socialBenefit = insuranceData[0]?.benefits || [];
  const getAllInsuranceDetails = async () => {
      const { data, error, message } = await getAllInsurances(selectedCompanyEntity);
      if (!error) {
        setInsuranceData(data);
      } else {
        toast.error(message)
      }   
  };
  
  useEffect(() => {
    selectedCompanyEntity && getAllInsuranceDetails(selectedCompanyEntity);
  }, [selectedCompanyEntity]);
  
  // Track benefits screen view
  useEffect(() => {
    trackAnalyticsEvent('BENEFICIARY_BENEFITS_SCREEN_VIEW', {
      manufacturer_id: userData?.manufacturer_id || '',
      user_id: userData?.id || ''
    });
  }, [userData?.manufacturer_id, userData?.id]);

  return (
    <Box sx={{ p: { xs:2, md:3 } }}>
        <Entity
          supplierLabel="Manufacturer"
          entityLabel="SAP Code"
          // gridSizes={{
          //   supplier: { xs: 6, sm: 4 },
          //   entity: { xs: 6, sm: 4 }
          // }}
          forceRefresh={true}
        />
        <ToggleButtonGroup
            value={selectedTab}
            exclusive
            onChange={handleTabChange}
            sx={{ mb: 2 }}
            aria-label="benefit selection"
        >
            {insuranceData.map((benefit, index) => (
              <StyledToggleButton key={index} value={index}>
                  {benefit.display_name}
              </StyledToggleButton>
            ))}
        </ToggleButtonGroup>
        <Grid container spacing={2} sx={{ mb: 2 }}>
          {socialBenefit.map((item, index) => (
            <Grid item xs={12} md={6} key={index}>
                <BenefitCard item={item} selectedCompanyEntity={selectedCompanyEntity}/>
            </Grid>
          ))} 
        </Grid>
    </Box>
  );
};

export default Benefits;
